import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "egt_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// Auth
export async function adminLogin(password) {
  const r = await axios.post(`${API}/admin/login`, { password });
  setToken(r.data.token);
  return r.data;
}
export async function adminVerify() {
  const r = await axios.get(`${API}/admin/verify`, { headers: authHeaders() });
  return r.data;
}

// Teams
export async function listTeams() {
  const r = await axios.get(`${API}/teams`);
  return r.data;
}
export async function createTeam(payload) {
  const r = await axios.post(`${API}/teams`, payload, { headers: authHeaders() });
  return r.data;
}
export async function updateTeam(id, payload) {
  const r = await axios.put(`${API}/teams/${id}`, payload, { headers: authHeaders() });
  return r.data;
}
export async function deleteTeam(id) {
  const r = await axios.delete(`${API}/teams/${id}`, { headers: authHeaders() });
  return r.data;
}

// Rules
export async function listRules() {
  const r = await axios.get(`${API}/rules`);
  return r.data;
}
export async function updateRule(id, payload) {
  const r = await axios.put(`${API}/rules/${id}`, payload, { headers: authHeaders() });
  return r.data;
}
export async function createRule(payload) {
  const r = await axios.post(`${API}/rules`, payload, { headers: authHeaders() });
  return r.data;
}
export async function deleteRule(id) {
  const r = await axios.delete(`${API}/rules/${id}`, { headers: authHeaders() });
  return r.data;
}

// Bracket
export async function getBracket() {
  const r = await axios.get(`${API}/bracket`);
  return r.data;
}
export async function generateBracket() {
  const r = await axios.post(`${API}/bracket/generate`, {}, { headers: authHeaders() });
  return r.data;
}
export async function resetBracket() {
  const r = await axios.post(`${API}/bracket/reset`, {}, { headers: authHeaders() });
  return r.data;
}
export async function setMatchWinner(matchId, payload) {
  const r = await axios.put(`${API}/bracket/match/${matchId}`, payload, { headers: authHeaders() });
  return r.data;
}
export async function undoMatchWinner(matchId) {
  const r = await axios.delete(`${API}/bracket/match/${matchId}/winner`, { headers: authHeaders() });
  return r.data;
}

export const LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_e72e0073-03cd-4ce4-9c15-5978dcab2338/artifacts/xb6d93ki_MainLogo.png",
  icon: "https://customer-assets.emergentagent.com/job_e72e0073-03cd-4ce4-9c15-5978dcab2338/artifacts/vbcn870b_3%20%282%29.png",
};

export const DISCORD_URL = "https://discord.gg/EliteGorillaTag";
